import type { TemplateResult } from 'lit-html';
import type { Connector } from './types.js';

/**
 * Connector-specific screens. Every connector gets a generic Settings tab (on/off, settings,
 * credentials, scopes) on its page at #/connectors/{name}; a connector with its own screens adds
 * tabs here (#/connectors/{name}/{tab}/{rest…}). The main navigation never grows per connector.
 */
export interface ConnectorTab {
  id: string;
  label: string;
  /** `rest` is whatever follows the tab in the route, e.g. a record ID ('' on the tab's own page). */
  load(rest: string): Promise<void>;
  view(c: Connector): TemplateResult;
}

export interface ConnectorUi {
  tabs: ConnectorTab[];
  /** Extra panels at the top of the Settings tab (e.g. account status). */
  loadSettings?(): Promise<void>;
  settings?(c: Connector): TemplateResult;
}

/** Link to a connector page: connectorHref('stannp', 'mail', id) → #/connectors/stannp/mail/{id}. */
export const connectorHref = (name: string, ...parts: string[]): string =>
  `#/connectors/${[name, ...parts].filter(Boolean).map(encodeURIComponent).join('/')}`;
